export default function AboutSection() {
  return (
    <section id="about" className="bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-28 lg:py-36">
        <p className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#F7F6F2] mb-6">
          06 — About
        </p>
        <h2
          data-testid="about-headline"
          className="font-heading font-light uppercase tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl max-w-4xl"
        >
          Commercial thinking. Sporting instinct<span className="text-[#F7F6F2]">.</span>
        </h2>

        <div
          data-testid="about-body"
          className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8 max-w-5xl"
        >
          <p className="text-base sm:text-lg font-light text-neutral-300 leading-relaxed">
            QUALIVE was founded by executives from private equity and
            investment backgrounds who saw first hand how the right sports
            partnership could create meaningful value for businesses.
          </p>
          <p className="text-base sm:text-lg font-light text-neutral-300 leading-relaxed">
            Rather than viewing sponsorship simply as brand exposure, QUALIVE
            approaches sport through a commercial lens, considering audience,
            market positioning, customer acquisition, hospitality, brand equity
            and long term strategic value.
          </p>
          <p className="text-base sm:text-lg font-light text-neutral-300 leading-relaxed">
            Today, QUALIVE works across Formula One and football, connecting
            ambitious businesses with teams, clubs and sporting properties
            where there is genuine commercial alignment.
          </p>
          <p className="text-base sm:text-lg font-light text-neutral-300 leading-relaxed">
            Our approach combines the discipline of investment thinking with a
            deep understanding of how relationships, culture and visibility can
            create value in global sport.
          </p>
        </div>

        <div className="mt-20 pt-14 border-t border-white/10 grid grid-cols-1 lg:grid-cols-2 gap-10 max-w-6xl">
          <div>
            <p className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-neutral-500 mb-6">
              Founded on a simple belief
            </p>
            <p
              data-testid="about-belief"
              className="font-heading font-light text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-snug text-[#F7F6F2]"
            >
              The best sports partnerships should be commercially valuable, not
              simply visible.
            </p>
          </div>
          <p className="text-base sm:text-lg font-light text-neutral-400 leading-relaxed self-end">
            QUALIVE helps brands identify where sport can support wider
            business objectives, while helping rights holders find partners
            capable of creating value beyond the sponsorship fee.
          </p>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row gap-4 sm:gap-12">
          <span className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-neutral-500">
            Founded 2023
          </span>
          <span className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-neutral-500">
            Independent
          </span>
          <span className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-neutral-500">
            International
          </span>
          <span className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-neutral-500">
            Focused
          </span>
        </div>
      </div>
    </section>
  );
}
